<template>
  <div class="flex flex-col lg:flex-row w-full h-full mx-auto py-4 lg:p-6">
    <div class="bg-white shadow-lg rounded-lg w-12/12 lg:w-2/6 mx-4 py-4 overflow-hidden mb-4 lg:mb-0">
      
      <div class="h-full overflow-auto px-4">
      
        <div class="flex items-center gap-1 justify-end pb-4 sticky top-0 bg-white relative z-10">
          <h1 class="flex items-center font-bold text-gray-900 px-2 py-2 gap-1 leading-tight tracking-wider">
            Mis Proyectos
            <span class="rounded-full px-4 py-1 bg-gray-200">
              {{ filteredProjects.length }}
            </span>
          </h1>
          <div class="flex-1"></div>
          <button
            class="border p-1 rounded border-gray-700"
            @click="changeFormOrder"
            aria-label="Ordenar proyectos ascentente o descendente"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
              />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>
          <btn-action
            v-if="category == 'ADMINISTRADOR'"
            class="px-3 py-1 bg-transparent font-semibold hover:text-white border rounded"
            @click="openAddModal()"
            :colorT="color_terciario"
          >
            Crear
          </btn-action>
        </div>
        
        <input
          type="text"
          v-model="search"
          placeholder="Búsqueda de proyectos"
          class="w-full appearance-none border rounded py-2 px-3 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white"
        />

        <div class="w-full">
          <div class="w-full relative">
            <select
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 mb-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              name="status"
              id="status"
              v-model="categoryFilter"
              @change="updateselectProject()"
            >
              <option selected value="-1">Todos</option>
              <option v-for="category in categories" :key="category.id" :value="category.id">
                {{ category.nombre }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilter = 'TODOS'), filteredProjects, updateselectProject()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'TODOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            Todos {{ filteredByAll.length }}
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilter = 'SIN EVALUAR'),
                filteredProjects,
                updateselectProject()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'SIN EVALUAR'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            Pendientes {{ filteredByChecked.length }}
          </btn-action>
        </div>
        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilter = 'NO REVISADOS'),
                filteredProjects,
                updateselectProject()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'NO REVISADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            En proceso {{ filteredByOpen.length }}
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilter = 'RECHAZADOS'),
                filteredProjects,
                updateselectProject()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'RECHAZADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            Rechazados {{ filteredByCanceled.length }}
          </btn-action>
        </div>
        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilter = 'EN REVISIÓN'),
                filteredProjects,
                updateselectProject()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'EN REVISIÓN'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            En revisión {{ filteredByAssigned.length }}
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilter = 'APROBADOS'),
                filteredProjects,
                updateselectProject()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilter === 'APROBADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent'
            ]"
            :colorT="color_terciario"
          >
            Aprobados {{ filteredByAttended.length }}
          </btn-action>
        </div>


        <div-selected-styled
          v-for="event in filteredProjects"
          :key="event.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{ 'bg-selected': event.id === currentProject.id }"
          @click="selectProject(event)"
          :colorT="color_terciario"
        >
          <img
            :src="event.path_media_folder"
            class="h-12 w-12 object-cover"
            @error="loadDefaultImg"
          />
          <div class="flex flex-col flex-grow ml-2">
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-100'
                  : 'text-gray-900'
              ]"
              class="group-hover:text-gray-900"
            >
              {{ event.nombre }}
            </span>
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-100'
                  : 'text-gray-900'
              ]"
              class="group-hover:text-gray-900"
              ><span v-if="event.fecha_creacion">{{ event.fecha_creacion | moment("DD/MM/YYYY hh:mm A") }}</span></span
            >
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-300'
                  : 'text-gray-700'
              ]"
              class="text-sm group-hover:text-gray-700"
              >{{ event.institucion }}</span
            >
            <span
              :class="[
                event.id === currentProject.id
                  ? 'text-gray-300'
                  : 'text-gray-700'
              ]"
              class="text-sm group-hover:text-gray-700"
              >F-{{ event.id }} {{ event.status }}</span
            >
            <div class="flex">
              <svg
                v-if="event.es_privada"
                fill="#000000"
                height="20px"
                width="20px"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 352.644 352.644"
                xml:space="preserve"
              >
                <path
                  d="M324.478,51.943L177.985,0.285c-1.076-0.38-2.25-0.38-3.326,0L28.166,51.943c-1.999,0.705-3.337,2.595-3.337,4.715  c0,52.278,13.834,112.711,37.955,165.805c19.567,43.069,54.751,100.519,111.248,129.625c0.719,0.37,1.504,0.555,2.29,0.555  c0.786,0,1.571-0.185,2.29-0.555c56.497-29.106,91.681-86.556,111.248-129.625c24.121-53.094,37.955-113.527,37.955-165.805  C327.815,54.538,326.477,52.648,324.478,51.943z M236.322,222.07h-120c-2.549,0-4.615-2.066-4.615-4.615  c0-31.84,22.326-41.677,34.321-46.961c2.31-1.018,5.394-2.376,6.478-3.226c0.269-3.704-1.259-5.735-4.534-9.705  c-4.518-5.476-10.703-12.974-10.703-29.501c0-28.058,14.965-45.487,39.054-45.487c24.089,0,39.053,17.429,39.053,45.487  c0,16.527-6.186,24.026-10.702,29.501c-3.276,3.971-4.804,6.001-4.535,9.705c1.084,0.85,4.168,2.208,6.479,3.225  c11.994,5.285,34.321,15.121,34.321,46.962C240.937,220.003,238.871,222.07,236.322,222.07z"
                />
              </svg>
            </div>
          </div>
          <div
            v-if="event.en_pausa === true"
            class="flex self-start justify-self-end text-xs"
          >
            <div
              class="px-3 py-1 rounded-full border-2 border-blue-700 text-xs text-white bg-blue-500"
            >
              En pausa
            </div>
          </div>
        </div-selected-styled>
      </div>
    </div>

    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-12/12 lg:w-4/6 mx-4 py-8 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap">

          <div class="w-full pb-2 text-right space-y-2">
            <btn-action
              v-if="currentProject.geometria !== null"
              id="downGeojson"
              v-on:click="toGeojsonFile()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
              >Geojson</btn-action
            >

            <btn-action
              v-if="currentProject.geometria !== null"
              id="downKML"
              v-on:click="toKMLFile()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
              >KML</btn-action
            >

            <btn-action
              v-if="currentProject.geometria !== null"
              id="downSHP"
              v-on:click="toSHPFile()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
              >Shapefile (zip)</btn-action
            >
            <btn-action
              v-if="currentProject.qty_levantamientos > 0"
              v-on:click="showingConfirmDownload = true"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
            >
              Descargar Aportes
            </btn-action>
            <btn-action
              v-if="currentProject.qty_levantamientos > 0"
              v-on:click="downloadRaisingProjectJSON()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
            >
              Descargar JSON
            </btn-action>
            <btn-action
              v-if="currentProject.status !== 'SIN EVALUAR'"
              v-on:click="exportPDF()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
            >
              Descargar Reporte
            </btn-action>
            <btn-action
              v-if="
                currentProject.status === 'NO REVISADO' ||
                currentProject.status === 'EN REVISIÓN'
              "
              v-on:click="newChatModal()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
            >
              Mensajes
            </btn-action>
            <btn-action
              v-if="currentProject.status === 'SIN EVALUAR'"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 border hover:border-transparent rounded"
              @click="showingCheckedConfirm = true"
              :colorT="color_terciario"
            >
              Enviar a revision
            </btn-action>
            <btn-action
              v-if="currentProject.status !== 'APROBADO' && category == 'ADMINISTRADOR'"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 border hover:border-transparent rounded"
              @click="openEditModal()"
              :colorT="color_terciario"
            >
              Editar
            </btn-action>
            <btn-action
              v-if="
                currentProject.activo === true &&
                currentProject.status !== 'SIN EVALUAR'
              "
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 border hover:border-transparent rounded"
              @click="showingDeactivationConfirm = true"
              :colorT="color_terciario"
            >
              Desactivar
            </btn-action>
            <btn-action
              v-if="
                currentProject.activo === false &&
                currentProject.status !== 'SIN EVALUAR'
              "
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 border hover:border-transparent rounded"
              @click="showingActivationConfirm = true"
              :colorT="color_terciario"
            >
              Activar
            </btn-action>
            <button
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingDeleteConfirm = true"
              v-if="category == 'ADMINISTRADOR'"
            >
              Eliminar
            </button>
          </div>
        </div>

        <div class="w-full">

          <!--seccion de informacion -->
          <div class="flex w-full">
            <div class="flex flex-col w-full px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl">
              <p class="pb-1 pt-2 text-sm text-center font-bold tracking-widest">
                Información del proyecto
              </p>

              <div class="flex items-center">
                <div class="flex items-center w-1/2 text-left text-xs">
                  <div class="flex items-center w-full text-left text-xs">
                    <div
                      v-if="currentProject.status === 'NO REVISADO'"
                      class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} EN PROCESO
                    </div>
                    <div
                      v-if="currentProject.status === 'RECHAZADO'"
                      class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div
                      v-if="currentProject.status === 'EN REVISIÓN'"
                      class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div
                      v-if="currentProject.status === 'APROBADO'"
                      class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                    >
                      F-{{ currentProject.id }} {{ currentProject.status }}
                    </div>
                    <div class="pl-2">
                      <div
                        v-if="currentProject.activo === true"
                        class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                      >
                        Activo
                      </div>
                      <div
                        v-if="currentProject.activo === false"
                        class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                      >
                        Inactivo
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2 text-right text-xs text-gray-900">
                  <span v-if="currentProject.fecha_levantamiento">{{
                    currentProject.fecha_levantamiento
                      | moment("DD/MM/YYYY hh:mm a")
                  }}</span>
                </div>
              </div>
              <br />
              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre del proyecto:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Institución:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.institucion }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Líder de proyecto:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.lider }}
                </div>
              </div>

              <!-- <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Descripción:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.descripcion }}
                </div>
              </div> -->

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Objetivo:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.objetivo }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold"
                    >Especificaciones multimedia:</span
                  >
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.especificaciones_multimedia }}
                </div>
              </div>

              <!-- <div
                class="flex w-full text-xs pt-2 tracking-wide "
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Producto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.producto }}
                </div>
              </div> -->

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.activo === true"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Creado por:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre_propietario }}
                  {{ currentProject.apellido_propietario }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Fecha de creación:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  <span v-if="currentProject.fecha_creacion">{{
                    currentProject.fecha_creacion | moment("DD/MM/YYYY hh:mm a")
                  }}</span>
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold"
                    >Fecha de aceptación / activación:</span
                  >
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  <span v-if="currentProject.fecha_aceptacion">{{
                    currentProject.fecha_aceptacion
                      | moment("DD/MM/YYYY hh:mm a")
                  }}</span>
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.id_curador !== null"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span
                    class="font-bold"
                    v-if="currentProject.status !== 'NO REVISADO'"
                    >Revisado por:</span
                  >
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs ml-2 mb-2 text-left"
                >
                  {{ currentProject.nombre_curador }}
                  {{ currentProject.apellido_curador }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.activo === false"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Fecha de desactivación:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  <span v-if="currentProject.fecha_desactivacion">{{
                    currentProject.fecha_desactivacion
                      | moment("DD/MM/YYYY hh:mm a")
                  }}</span>
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.activo === false"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Desactivado por:</span>
                </div>
                <div
                  class="w-full lg:w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre_curador_desactivate }}
                  {{ currentProject.apellido_curador_desactivate }}
                </div>
              </div>

              <div
                v-if="currentProject.file_type == 'video/mp4'"
                class="flex justify-center py-2 w-full"
              >
                <video
                  :src="currentProject.path_media_folder"
                  width="640"
                  height="480"
                  controls
                  controlslist="nodownload"
                />
              </div>
              <div class="flex justify-center py-2 w-8/12 mx-auto">
                <v-lazy-image
                  v-if="currentProject.imagen !== null"
                  :src="replaceResizeURL(currentProject.path_media_folder)"
                />
              </div>
            </div>
          </div>
          <!--/seccion de informacion -->

          <!-- sección de ficha -->
          <div class="flex w-full">
            <div class="flex flex-col w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl">
              <p 
                v-if="currentProject.ficha_proyecto"
                class="py-2 text-sm text-center font-bold tracking-widest"
              >
                Ficha de información
              </p>

              <div
                v-for="(one_question, index) in currentQuestions"
                :key="'q_' + index"
                :class="nestedStatusFicha[index] ? 'pl-6 border-l-4 border-gray-300 ml-2 mb-4' : 'mb-4'"
              >
                <div v-if="one_question.tipo === 'SECCION'" class="w-full mb-2 bg-gray-200 border-l-4 border-gray-500 p-2 rounded shadow-sm">
                  <label class="block uppercase tracking-wider text-gray-800 text-sm font-bold text-left">
                    {{ one_question.numero_pregunta }}.- {{ one_question.texto }}
                    <template v-if="one_question.nota_para_registrante != ''">
                      ({{ one_question.nota_para_registrante }})
                    </template>
                  </label>
                  <p v-if="one_question.descripcion != ''">
                    {{ one_question.descripcion }}
                  </p>
                </div>

                <div v-else-if="one_question.texto != null">
                  <div class="my-2">
                    <label
                      class="block uppercase tracking-wider text-gray-700 text-xs font-bold "
                      >{{ one_question.numero_pregunta }}.-
                      {{ one_question.texto }}
                      <template v-if="one_question.nota_para_registrante != ''">
                        ({{ one_question.nota_para_registrante }})
                      </template>
                    </label>
                    <p 
                      v-if="one_question.descripcion != ''"
                      class="pl-5 text-xs text-gray-800 my-1"
                    >
                      {{ one_question.descripcion }}
                    </p>
                  </div>


                  <div class="pl-5">
                    <div v-if="one_question.tipo === 'ABIERTA'">
                      <textarea-styled
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        value=""
                        disabled
                        :colorT="color_terciario"
                      />
                    </div>

                    <template v-if="one_question.tipo == 'SELECCION'">
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="radio"
                            name="question"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>

                      <div
                        v-if="one_question.otro === true"
                        class="flex items-left text-gray-700 font-bold"
                        style="align-items: baseline"
                      >
                        Otro: &nbsp; &nbsp;
                        <input-styled
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          placeholder="Escriba otra opción"
                          disabled
                          :colorT="color_terciario"
                        />
                      </div>
                    </template>

                    <template v-if="one_question.tipo == 'MULTISELECCION'">
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="checkbox"
                            name="question"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>

                      <div
                        v-if="one_question.otro === true"
                        class="flex items-left text-gray-700 font-bold"
                        style="align-items: baseline"
                      >
                        Otro: &nbsp; &nbsp;
                        <input-styled
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          placeholder="Escriba otra opción"
                          disabled
                          :colorT="color_terciario"
                        />
                      </div>
                    </template>

                    <template
                      v-if="one_question.tipo == 'SELECCION_CONDICIONAL'"
                    >
                      <template v-for="(opt, index) in one_question.opciones">
                        <div class="flex items-center text-gray-700 font-bold">
                          <input
                            class="mr-2 leading-tight"
                            type="radio"
                            name="question"
                            :value="opt"
                            disabled
                          />
                          <span>
                            {{ opt }}
                          </span>
                        </div>
                      </template>

                      <template
                        v-for="(opt, index) in one_question.pregunta_condicion"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ opt.id }}.-
                          <span style="color: #909696">({{ index }})</span>
                          {{ opt.texto }}

                          <template v-if="opt.nota_para_registrante != ''">
                            ({{ opt.nota_para_registrante }})
                          </template>
                        </label>

                        <template v-if="opt.tipo == 'SELECCION'">
                          <!-- pregunta condicional de selecion -->
                          <template v-for="(opt1, index) in opt.opciones">
                            <div
                              class="flex items-center text-gray-700 font-bold"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="radio"
                                name="question"
                                :value="opt"
                                disabled
                              />
                              <span>
                                {{ opt1 }}
                              </span>
                            </div>
                          </template>
                        </template>

                        <div v-if="opt.tipo === 'ABIERTA'">
                          <!-- pregunta condicional abierta -->
                          <textarea-styled
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="color_terciario"
                          />
                        </div>

                        <template v-if="opt.tipo == 'CAMPOS' || opt.tipo == 'GRUPO_REPETIBLE' || opt.tipo == 'MINI_FORMULARIO'">
                          <!-- pregunta condicional de campos -->
                          <template v-for="(opt1, index) in opt.campos">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ opt1.texto }}</label
                              >
                              <input-styled
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                                :colorT="color_terciario"
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>

                    <template v-if="one_question.tipo == 'OPCION_SEGUIMIENTO'">
                      <div v-for="(concepto, cIdx) in one_question.conceptos" :key="'concepto_' + cIdx" class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2 text-left">{{ concepto }}</label>
                        <div class="flex items-center gap-4 text-gray-700 font-bold mb-2">
                          <div class="flex items-center gap-2">
                            <input type="radio" disabled />
                            <span>{{ one_question.opcion_si }}</span>
                          </div>
                          <div class="flex items-center gap-2">
                            <input type="radio" disabled />
                            <span>{{ one_question.opcion_no }}</span>
                          </div>
                        </div>
                      </div>
                    </template>

                    <template v-if="one_question.tipo == 'CAMPOS' || one_question.tipo == 'GRUPO_REPETIBLE' || one_question.tipo == 'MINI_FORMULARIO'">
                      <template v-for="(opt, index) in one_question.campos">
                        <div class="flex w-full items-center justify-center">
                          <label
                            class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                            >{{ opt.texto }}</label
                          >
                          <input-styled
                            class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="color_terciario"
                          />
                        </div>
                      </template>
                    </template>

                    <template v-if="one_question.hasOwnProperty('subpregunta')">
                      <!-- Subpreguntas -->
                      <template
                        v-for="(opt, index) in one_question.subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ opt.numero_pregunta }}.-
                          {{ opt.texto }}
                          <template v-if="opt.nota_para_registrante != ''">
                            ({{ opt.nota_para_registrante }})
                          </template>
                        </label>
                        <div v-if="opt.tipo === 'ABIERTA'">
                          <!-- Subpregunta abierta -->
                          <textarea-styled
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            value=""
                            disabled
                            :colorT="color_terciario"
                          />
                        </div>

                        <template v-if="opt.tipo == 'SELECCION'">
                          <!-- Subpregunta de selección -->
                          <template v-for="(opt, index) in opt.opciones">
                            <div
                              class="flex items-center text-gray-700 font-bold"
                            >
                              <input
                                class="mr-2 leading-tight"
                                type="radio"
                                name="question"
                                :value="opt"
                                disabled
                              />
                              <span>
                                {{ opt }}
                              </span>
                            </div>
                          </template>

                          <div
                            v-if="opt.otro === true"
                            class="flex items-left text-gray-700 font-bold"
                            style="align-items: baseline"
                          >
                            Otro: &nbsp; &nbsp;
                            <input-styled
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              value=""
                              placeholder="Escriba otra opción"
                              disabled
                              :colorT="color_terciario"
                            />
                          </div>
                        </template>

                        <template v-if="opt.tipo == 'CAMPOS' || opt.tipo == 'GRUPO_REPETIBLE' || opt.tipo == 'MINI_FORMULARIO'">
                          <!-- Subpregunta de campos -->
                          <template v-for="(opt, index) in opt.campos">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ opt.texto }}</label
                              >
                              <input-styled
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                value=""
                                disabled
                                :colorT="color_terciario"
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                    <template v-if="one_question.tipo === 'MATRIZ'">
                      <div class="overflow-x-auto mb-3 pl-4">
                        <table class="w-full text-left border-collapse">
                          <thead>
                            <tr>
                              <th class="border-b-2 p-2"></th>
                              <th
                                v-for="(col, colIdx) in one_question.columnas"
                                :key="'col' + colIdx"
                                class="border-b-2 p-2 text-sm text-gray-700 font-bold text-center"
                              >
                                {{ col }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(fila, filaIdx) in one_question.filas"
                              :key="'fila' + filaIdx"
                            >
                              <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                {{ fila }}
                              </td>
                              <td
                                v-for="(col, colIdx) in one_question.columnas"
                                :key="'cell' + colIdx"
                                class="border-b p-2 text-center"
                              >
                                <input
                                  type="radio"
                                  :name="'matrix_' + index + '_' + filaIdx"
                                  :value="col"
                                  disabled
                                  class="leading-tight"
                                />
                              </td>
                            </tr>
                            <tr v-if="one_question.otro">
                              <td class="border-b p-2 text-sm text-gray-500 italic">
                                Otro (opcional)
                              </td>
                              <td
                                v-for="(col, colIdx) in one_question.columnas"
                                :key="'cell_otro_' + colIdx"
                                class="border-b p-2 text-center"
                              >
                                <input
                                  type="radio"
                                  :name="'matrix_' + index + '_otro'"
                                  :value="col"
                                  disabled
                                  class="leading-tight"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                    <div v-if="one_question.tipo === 'FECHA'">
                      <div class="w-1/2 lg:w-2/3 px-3 mb-6 md:mb-0">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-gray-200 focus:select-none"
                          type="date"
                          name="question"
                          v-on:click.prevent=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /sección de ficha -->

          <div class="flex w-full pb-6">
            <div
              v-if="dataLoaded"
              class="w-2/3 h-80 mx-auto py-4 px-4 overflow-hidden"
            >
              <div>
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por estado</span
                >
              </div>
              <doughnut-lev-chart
                :chartData="statusData"
                :options="doughnutChartOptions"
                :css-classes="'w-1/2 h-64 py-2 mx-auto'"
              ></doughnut-lev-chart>
            </div>
          </div>

          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full lg:mx-4 py-4 px-4">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por fechas</span
                >
              </div>
              <div class="flex w-full">
                <div class="w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    for="fechaInicio"
                    >Fecha inicial</label
                  >
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="fechaInicio"
                    type="date"
                    name="fechaInicio"
                    v-model="fechaInicio"
                    :max="startMaxDate"
                    @change="checkStartCalendar"
                  />
                </div>

                <div class="w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    for="fechaFin"
                    >Fecha final</label
                  >
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="fechaFin"
                    type="date"
                    name="fechaFin"
                    v-model="fechaFin"
                    :min="endMinDate"
                    :max="endMaxDate"
                    @change="checkEndCalendar"
                  />
                </div>
              </div>
              <bar-chart
                :chartData="dataByDate"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByDateLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full mx-4 py-4 px-4">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por municipios</span
                >
              </div>

              <bar-chart
                :chartData="dataByMun"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByMunLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full mx-4 py-4 px-4 overflow-hidden">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por año</span
                >
              </div>
              <div class="flex w-full">
                <div class="w-full lg:w-1/3 px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    for="selectedYear"
                    >Seleccionar año</label
                  >
                  <div class="relative">
                    <select
                      v-model="selectedYear"
                      name="selectedYear"
                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      @change="fetchStatisticsByYear"
                    >
                      <option v-for="(year, index) in years" :value="year" :key="index">{{ year }}</option>
                    </select>
                    <div
                      class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                    >
                      <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <bar-chart
                :chartData="dataByYear"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByYearLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex flex-wrap" v-if="dataMediaLoaded">
            <div class="w-full pb-2">
              <span class="font-semibold text-lg tracking-wider"
                >Últimos archivos multimedia agregados</span
              >
            </div>
            <div
              v-for="(media, mediaIndex) in multimediaList"
              :key="mediaIndex"
              class="flex w-auto h-32 px-2 pb-4"
              style="flex: 1 0 21%"
            >
              <img
                v-if="media.mimeType.includes('image')"
                :src="replaceURL(media.fileName, 'img')"
                class="h-full w-full object-contain"
                alt=""
              />
              <video
                v-if="media.mimeType.includes('video')"
                :src="replaceURL(media.fileName, 'video')"
                class="h-full w-full bg-gray-300"
                controls
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>

    <project-modal
      :showing="showEventModal"
      :event="modalEvent"
      :aux_event="aux_modalEvent"
      :modalAction="modalAction"
      @close="closeModal"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></project-modal>

    <raising-chat-modal
      :showing="showCommentsModal"
      @close="showCommentsModal = false"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></raising-chat-modal>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Evento guardado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingDeactivationConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea desactivar el proyecto?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deleteProject()"
        >
          Desactivar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingDeactivationConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingActivationConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea activar el proyecto?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deleteProject()"
        >
          Activar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingActivationConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingDeleteConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Realmente desea eliminar el proyecto? Esta acción no se puede
          deshacer
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="realDeleteProject()"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingDeleteConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingCheckedConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Realmente desea enviar a revisión el proyecto? Esta acción no se
          puede deshacer
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="sendCheckedProject()"
        >
          Enviar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingCheckedConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmDownload">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea descargar los aportes de este proyecto?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="downloadRaisingProject()"
        >
          Descargar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmDownload = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDeactivation">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Proyecto desactivado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDeactivation = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Proyecto eliminado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingProjectNotEmpty">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          El proyecto no se puede eliminar, tiene aportes asociados
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingProjectNotEmpty = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessActivation">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Proyecto activado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessActivation = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="2000"
      :filename="currentProject.nombre"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="letter"
      pdf-orientation="portrait"
      ref="html2Pdf"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="hasDownloaded($event)"
    >
      <section slot="pdf-content">
        <!-- PDF Content Here -->

        <section class="pdf-item">
          <div class="flex w-full pl-4">
            <div
              class="flex flex-col w-8/12 px-3 mx-auto my-3 mb-2 bg-gray-400 rounded-lg shadow-xl"
            >
              <div class="flex w-full items-center justify-center pb-4">
                <span>REPORTE GENERADO</span>
              </div>
            </div>
          </div>

          <div class="flex w-full pl-4">
            <div class="flex flex-col w-full px-4">
              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre del proyecto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Folio:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  F-{{ currentProject.id }} {{ currentProject.status }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Estado:</span>
                </div>
                <div
                  v-if="currentProject.activo === true"
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  Activo
                </div>
                <div
                  v-if="currentProject.activo === false"
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  Inactivo
                </div>
              </div>

              <!-- <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Institución:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.institucion }}
                </div>
              </div> -->

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Líder de proyecto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.lider }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Objetivo:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.objetivo }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold"
                    >Especificaciones multimedia:</span
                  >
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.especificaciones_multimedia }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Creado por:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentProject.nombre_propietario }}
                  {{ currentProject.apellido_propietario }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Fecha de creación:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  <span v-if="currentProject.fecha_creacion">{{
                    currentProject.fecha_creacion | moment("DD/MM/YYYY hh:mm a")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="html2pdf__page-break" />
        <section class="pdf-item">
          <div class="flex w-full">
            <div class="flex flex-col w-full mx-4 px-4">
              <div class="w-full">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por año ( {{ selectedYear }} )</span
                >
              </div>
              <div class="w-full pb-2">
                <span class="text-xs tracking-wider"
                  >Total {{ totalByYear }}</span
                >
              </div>
              <bar-chart
                :chartData="dataByYear"
                :options="barChartOptions"
                :css-classes="'w-96 h-64 py-2 mx-auto'"
                v-if="dataByYearLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full mx-4 py-4 px-4">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por fechas (<span v-if="fechaInicio && fechaFin">{{
                    fechaInicio | moment("DD/MM/YYYY")
                  }}
                  - {{ fechaFin | moment("DD/MM/YYYY") }}</span>)</span
                >
              </div>
              <bar-chart
                :chartData="dataByDate"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByDateLoaded"
              >
              </bar-chart>
            </div>
          </div>
        </section>
        <div class="html2pdf__page-break" />
        <section class="pdf-item">
          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full mx-4 py-4 px-4">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por municipios</span
                >
              </div>

              <bar-chart
                :chartData="dataByMun"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByMunLoaded"
              >
              </bar-chart>
            </div>
          </div>

          <div class="flex w-full pb-6">
            <div class="flex flex-col w-full mx-4 py-4 px-4 overflow-hidden">
              <div class="w-full pb-2">
                <span class="font-semibold text-lg tracking-wider"
                  >Levantamientos por año {{ selectedYear }}</span
                >
              </div>
              <bar-chart
                :chartData="dataByYear"
                :options="barChartOptions"
                :css-classes="'w-full h-88 py-2 mx-auto'"
                v-if="dataByYearLoaded"
              >
              </bar-chart>
            </div>
          </div>
        </section>
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import urlMixin from "@/mixins/urlMixin";
import ProjectModal from "./ProjectModal";

import AlertDialog from "./AlertDialog";

import moment from "moment";

import VueHtml2pdf from "vue-html2pdf";


import L from "leaflet";

import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import "leaflet-kmz/dist/leaflet-kmz";
import "leaflet-kml/L.KML";
import { Icon } from "leaflet";
import EventBus from "../event-bus";

import RaisingChatModal from "./RaisingChatModal";

import BarChart from "./BarChart.vue";

import DoughnutLevChart from "./DoughnutLevChart.vue";

import jsPDF from "jspdf";

import tokml from "tokml";

import shpwrite from "shp-write";


import { styled } from "@egoist/vue-emotion";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

const BtnAction = styled("button")`
  color: ${props => props.colorT};
  border-color: ${props => props.colorT};
  &.bg-selected {
    background-color: ${props => props.colorT};
    color: #fff;
  }
  &:hover {
    background-color: ${props => props.colorT};
  }
`;

const DivSelectedStyled = styled("div")`
  &.bg-selected {
    background-color: ${props => props.colorT};
  }
  &:hover {
    background-color: #d1d5db;
  }
`;

const TextareaStyled = styled("textarea")`
  border-color: ${props => props.colorT};
  resize: none;
`;

const InputStyled = styled("input")`
  border-color: ${props => props.colorT};
`;

export default {
  mixins: [urlMixin],
  name: "projects-list",
  data() {
    return {
      geojsonRouter: null,
      projects: [],
      search: "",
      currentQuestions: [],
      currentProject: {},
      showEventModal: false,
      showingSuccess: false,
      showingDeleteConfirm: false,
      showingCheckedConfirm: false,
      showingActivationConfirm: false,
      showingDeactivationConfirm: false,
      showingConfirmDownload: false,
      downloadActive: false,
      showingError: false,
      showingSuccessDeactivation: false,
      showingSuccessActivation: false,
      showingSuccessDelete: false,
      showingProjectNotEmpty: false,
      showCommentsModal: false,
      statusFilter: "TODOS",
      modalEvent: {},
      aux_modalEvent: {},
      modalAction: "",
      email: localStorage.getItem("email"),
      category: window.atob(localStorage.getItem("category")),
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      configDownload: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        },
        responseType: "blob"
      },
      showingCalendar: false,
      // showDuplicateEvents: false,
      // duplicateEvents: [],
      zoom: 12,
      center: [20.58651, -89.01501],
      //showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      formOrder: "upward",
      leafletMap: null,
      currentRouteLayer: null,
      kmzParser: null,
      layerKml: null,
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      categoryFilter: "-1",
      categories: [
        {
          id: 1,
          nombre: "Activo"
        },
        {
          id: 0,
          nombre: "Inactivo"
        }
      ],
      barChartOptions: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0
              }
            }
          ]
        }
      },
      doughnutChartOptions: {
        legend: {
          display: true,
          labels: {
            fontSize: 14,
            fontStyle: "bold"
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200
      },
      fechaInicio: null,
      fechaFin: null,
      dataByDate: {},
      dataByDateLoaded: false,
      startMaxDate: moment(new Date()).format("YYYY-MM-DD"),
      endMinDate: "",
      endMaxDate: moment(new Date()).format("YYYY-MM-DD"),
      multimediaList: [],
      dataMediaLoaded: false,
      firstYear: null,
      selectedYear: null,
      dataByYear: {},
      dataByYearLoaded: false,
      years: [],
      statusData: {},
      dataLoaded: false,
      dataByMun: {},
      dataByMunLoaded: false,
      totalByYear: 0,
      totalByMonth: 0,
      color_principal: "",
      color_secundario: "",
      color_terciario: ""
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LTileLayer,
    ProjectModal,
    AlertDialog,
    RaisingChatModal,
    BarChart,
    DoughnutLevChart,
    VueHtml2pdf,
    BtnAction,
    DivSelectedStyled,
    TextareaStyled,
    InputStyled
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.name) {
      let id = this.$route.query.id.toString();
      let name = this.$route.query.name.toString();
      this.search = `${id} ${name}`;
    }

    let endDate = new Date();

    let startDate = new Date();

    startDate.setMonth(startDate.getMonth() - 3);

    this.fechaInicio = moment(startDate).format("YYYY-MM-DD");
    this.fechaFin = moment(endDate).format("YYYY-MM-DD");

    EventBus.$emit("updateNotification", {});
    this.fetchProjects();

    this.selectedYear = new Date().getFullYear();
  },
  methods: {
    updateselectProject() {
      if (this.filteredProjects.length > 0) {
        this.selectProject(this.filteredProjects[0]);
      }
    },
    onMapReady: function () {
      this.$nextTick(() => {
        let that = this;
        const map = this.$refs.map.mapObject;
        //esri.basemapLayer("Topographic").addTo(map);
        this.leafletMap = map;

        this.kmzParser = new L.KMZParser({
          onKMZLoaded: function (layer, name) {
            that.geojsonRouter = null;

            if (that.layerKmz != null) {
              map.removeLayer(that.layerKmz);
              that.layerKmz = null;
            }

            that.layerKmz = layer;
            layer.addTo(map);
          }
        });
      });
    },
    fetchProjects() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/projects/getProjects",
          {
            user_id: localStorage.getItem("user_id"),
            email: localStorage.getItem("email"),
            category: window.atob(localStorage.getItem("category"))
          },
          this.config
        )
        .then(response => {
          this.projects = response.data.proyectos;
          this.$root.$emit("hideLoading");
          if (this.filteredProjects.length > 0) {
            this.selectProject(this.filteredProjects[0]);
          }
        })
        .catch(error => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    showPolygonInMap() {
      if (this.currentProject.geometria !== null) {
        if (this.currentProject.kml != null) {
          const type = this.currentProject.kml.split(".")[1];
          if (type == "kml") {
            this.resetFileGeometryInMap();
            this.geojsonRouter = null;
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", () => {
              this.loadKml(oReq.responseText);
            });
            oReq.open("GET", "../apidev/" + this.currentProject.kml);
            oReq.send();
          }

          if (type == "kmz") {
            this.resetFileGeometryInMap();
            this.kmzParser.load("../apidev/" + this.currentProject.kml);
          }
        } else {
          this.resetFileGeometryInMap();
          this.geojsonRouter = this.currentProject.geometria;
          if (this.geojsonRouter) {
            let boundingBoxGeojson = L.geoJSON(this.geojsonRouter);
            let boundingBox = boundingBoxGeojson.getBounds();
            this.$refs.map.mapObject.fitBounds(boundingBox);
          }
        }
      } else {
        this.resetFileGeometryInMap();
        this.geojsonRouter = null;
      }
    },
    resetFileGeometryInMap() {
      if (this.layerKmz != null) {
        this.leafletMap.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }

      if (this.layerKml != null) {
        this.leafletMap.removeLayer(this.layerKml);
        this.layerKml = null;
      }
    },

    loadKml(text) {
      if (this.leafletMap != null) {
        const parser = new DOMParser();
        this.new_kml = parser.parseFromString(text, "text/xml");
        this.layerKml = new L.KML(this.new_kml);
        this.leafletMap.addLayer(this.layerKml);
      }
    },
    selectProject(event) {
      this.$root.$emit("showLoading");
      event.es_institucion_option = event.es_institucion ? 1 : 0;
      this.currentProject = event;
      this.showPolygonInMap();

      if (event.es_notificado != null && event.es_notificado) {
        this.axios
          .post(
            "../apidev/projects/updateNotification",
            {
              id: this.currentProject.id
            },
            this.config
          )
          .then(() => {
            EventBus.$emit("updateNotification", {});
          })
          .catch(error => this.catchError(error));
      }

      this.axios
        .post(
          "../apidev/projects/getFichaRespuestasJson",
          {
            id_project: this.currentProject.id
          },
          this.config
        )
        .then(response => {
          this.downloadActive = response.data.levantamientos;
          this.currentQuestions = response.data.answers;
          this.$root.$emit("hideLoading");

          this.fetchStatisticsByProject();
          this.fetchMunicipiosByProject();
          this.fetchMediaByProject();

          this.fetchStatistics();

          this.fetchLevantamientoFirstDate();
          this.fetchStatisticsByYear();
        })
        .catch(error => this.catchError(error));
    },
    closeModal() {
      this.showEventModal = false;
      this.fetchProjects();
    },
    deleteProject() {
      this.$root.$emit("showLoading");

      if (this.currentProject.activo) {
        this.axios
          .put(
            "../apidev/projects/deactivate/" + this.currentProject.id,
            {
              user_id: localStorage.getItem("user_id"),
              activo: "false"
            },
            this.config
          )
          .then(() => {
            this.currentProject = {};
            this.fetchProjects();
            this.search = "";
            this.showingDeactivationConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessDeactivation = true;
          })
          .catch(error => {
            this.catchError(error);
            this.showingError = false;
          });
      } else {
        this.axios
          .put(
            "../apidev/projects/deactivate/" + this.currentProject.id,
            {
              user_id: localStorage.getItem("user_id"),
              activo: "true"
            },
            this.config
          )
          .then(() => {
            this.currentProject = {};
            this.fetchProjects();
            this.search = "";
            this.showingActivationConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessActivation = true;
          })
          .catch(error => {
            this.catchError(error);
            this.showingError = false;
          });
      }
    },
    realDeleteProject() {
      this.$root.$emit("showLoading");
      this.axios
        .delete(
          "../apidev/projects/deleteProject/" + this.currentProject.id,
          {
            headers: this.config.headers,
            data: {
              user_id: localStorage.getItem("user_id"),
              activo: "false"
            }
          }
        )
        .then(response => {
          //// removed console log
          //// removed console log
          if (response["data"]["status"] == "Proyecto eliminado") {
            this.currentProject = {};
            this.fetchProjects();
            this.search = "";
            this.showingDeleteConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessDelete = true;
          }
          if (
            response["data"]["status"] == "El proyecto tiene fichas asociadas"
          ) {
            this.showingDeleteConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingProjectNotEmpty = true;
          }
          /*           this.currentProject = {};
          this.fetchProjects();
          this.search = "";
          this.showingDeactivationConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingSuccessDeactivation = true; */
        })
        .catch(error => {
          //this.catchError(error);
          // removed console log
          this.showingDeleteConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },
    sendCheckedProject() {
      this.$root.$emit("showLoading");
      this.axios
        .put(
          "../apidev/projects/send/checked/" + this.currentProject.id,
          {
            user_id: localStorage.getItem("user_id")
          },
          this.config
        )
        .then(response => {
          this.showingCheckedConfirm = false;
          this.fetchProjects();
        })
        .catch(error => {
          // removed console log
          this.showingCheckedConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },
    openAddModal() {
      this.modalEvent = {
        imagen: ""
      };
      this.modalAction = "add";
      this.showEventModal = true;
    },
    openEditModal() {
      this.modalEvent = Object.assign({}, this.currentProject);
      this.aux_modalEvent = Object.assign({}, this.currentProject);
      this.modalAction = "edit";
      this.showEventModal = true;
    },
    loadDefaultImg(event) {
      event.target.src = require("@/assets/default-image-sm.jpg");
    },
    changeFormOrder() {
      this.formOrder = this.formOrder === "upward" ? "downward" : "upward";
    },
    downloadRaisingProject() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/downloads//proyect/exportLevantamientos/",
          {
            user_id: localStorage.getItem("user_id"),
            project_id: this.currentProject.id,
            project_name: this.currentProject.nombre
          },
          this.configDownload
        )
        .then(response => {
          const fileName =
            response.headers["content-disposition"].match(/filename=(.*)/)[1];
          var fileUrl = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/zip" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileUrl;
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$root.$emit("hideLoading");
          this.showingConfirmDownload = false;
        })
        .catch(error => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    downloadRaisingProjectJSON() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/downloads/proyect/exportLevantamientosJSON/",
          {
            user_id: localStorage.getItem("user_id"),
            project_id: this.currentProject.id,
            project_name: this.currentProject.nombre
          },
          this.configDownload
        )
        .then(response => {
          const fileName =
            response.headers["content-disposition"].match(/filename=(.*)/)[1];
          var fileUrl = window.URL.createObjectURL(
            new Blob([JSON.stringify(response.data)], { type: "application/json" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileUrl;
          fileLink.setAttribute("download", fileName.replace(/"/g, ''));
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    newChatModal() {
      this.showCommentsModal = true;
      EventBus.$emit("showChatModal", {
        raising_id: parseInt(this.currentProject.id),
        is_curador: false,
        menu: "PROYECTO",
        showNewMessageButton: true
      });
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
    fetchStatisticsByProject() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatisticsByProject",
          {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            idProyecto: this.currentProject.id
          },
          this.config
        )
        .then(response => {
          let statisticsByDate = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByDate.forEach(statistic => {
            labelsSet.push(moment(statistic.date).format("DD/MM/YYYY"));
            datasetData.push(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#B792F7",
                data: datasetData
              }
            ]
          };

          this.dataByDate = dataCollection;

          this.dataByDateLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchMunicipiosByProject() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosMunicipioByProject",
          {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            idProyecto: this.currentProject.id
          },
          this.config
        )
        .then(response => {
          this.totalByMonth = 0;
          let statisticsByMun = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByMun.forEach(statistic => {
            labelsSet.push(statistic.municipio);
            datasetData.push(statistic.total);
            this.totalByMonth += parseInt(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#B792F7",
                data: datasetData
              }
            ]
          };

          this.dataByMun = dataCollection;

          this.dataByMunLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    checkStartCalendar() {
      this.endMinDate = this.fechaInicio;
      if (this.fechaFin != null) {
        this.fetchStatisticsByProject();
        this.fetchMunicipiosByProject();
      }
    },
    checkEndCalendar() {
      this.startMaxDate = this.fechaFin;
      if (this.fechaInicio !== null) {
        this.fetchStatisticsByProject();
        this.fetchMunicipiosByProject();
      }
    },
    fetchMediaByProject() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosMediaByProject",
          {
            idProyecto: this.currentProject.id
          },
          this.config
        )
        .then(response => {
          let medias = response.data.media;
          this.multimediaList = [];
          medias.forEach(media => {
            let mediaList = JSON.parse(media.media_array);

            mediaList.forEach(multimedia => {
              this.multimediaList.push(multimedia);
            });
          });

          this.dataMediaLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },

    fetchStatisticsByYear() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatisticsProjectByYear",
          { year: this.selectedYear, idProyecto: this.currentProject.id },
          this.config
        )
        .then(response => {
          this.totalByYear = 0;
          let statisticsByDate = response.data.statistics;
          let labelsSet = [];
          let datasetData = [];
          statisticsByDate.forEach(statistic => {
            let monthLabel = moment(statistic.date).format("MMMM");
            monthLabel =
              monthLabel.charAt(0).toUpperCase() + monthLabel.slice(1);
            labelsSet.push(monthLabel);
            datasetData.push(statistic.total);
            this.totalByYear += parseInt(statistic.total);
          });

          let dataCollection = {
            labels: labelsSet,
            datasets: [
              {
                label: "Levantamientos",
                backgroundColor: "#B792F7",
                data: datasetData
              }
            ]
          };

          this.dataByYear = dataCollection;

          this.dataByYearLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchLevantamientoFirstDate() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getProjectLevantamientoFirstDate",
          { idProyecto: this.currentProject.id },
          this.config
        )
        .then(response => {
          if (response.data.firstdate.length > 0) {
            let firstDate = new Date(response.data.firstdate[0].date);
            this.firstYear = firstDate.getFullYear();

            let yearDifference = this.selectedYear - this.firstYear;

            for (let index = 0; index <= yearDifference; index++) {
              this.years.push(this.selectedYear - index);
            }

            this.years.sort();
          }
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchStatistics() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosStatusByProject",
          { idProyecto: this.currentProject.id },
          this.config
        )
        .then(response => {
          let statusArray = response.data.status;
          let data = [];
          let dataLabels = [];
          let dataColors = [];
          statusArray.forEach(status => {
            dataLabels.push(`${status.status}: ${status.total}`);
            data.push(status.total);

            switch (status.status) {
              case "NO REVISADO":
                dataColors.push("#00aedb");
                break;
              case "APROBADO":
                dataColors.push("#00b159");
                break;
              case "EN REVISIÓN":
                dataColors.push("#ffc425");
                break;
              case "RECHAZADO":
                dataColors.push("#d11141");
                break;
              default:
                break;
            }
          });

          let dataCollection = {
            labels: dataLabels,
            datasets: [
              {
                backgroundColor: dataColors,
                pointBackgroundColor: "white",
                borderWidth: 1,
                pointBorderColor: "#249EBF",
                data: data
              }
            ]
          };

          this.statusData = dataCollection;

          this.dataLoaded = true;
          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    exportPDF() {
      this.$refs.html2Pdf.generatePdf();
    },
    async beforeDownload() {
      this.$root.$emit("showLoading");
    },
    async hasDownloaded() {
      this.$root.$emit("hideLoading");
    },
    replaceResizeURL(path) {
      if(path != null && path != undefined){
        let filePathSplit = path.split(".");
        let resize_file_path = filePathSplit[0] + "_resize." + filePathSplit[1];

        if (!resize_file_path.startsWith('/') && !resize_file_path.startsWith('http')) {
          resize_file_path = '/' + resize_file_path;
        }

        return resize_file_path;
      }
      else{
        return "";
      }
    },
    toGeojsonFile() {
      // removed console log
      let geojsonObject = this.currentProject.geometria;

      let geojsonProperties = {};
      geojsonProperties["proyecto"] = this.currentProject.nombre;
      geojsonProperties["descripción"] = this.currentProject.descripcion;
      geojsonProperties["institucion"] = this.currentProject.institucion;
      geojsonProperties["fecha"] = new Date(this.currentProject.fecha_creacion);

      this.currentProject.geometria.properties = geojsonProperties;

      var convertedData =
        "text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(geojsonObject)); //encodeURIComponent recibe el geojson como texto
      document
        .getElementById("downGeojson")
        .setAttribute("href", "data:" + convertedData);
      document
        .getElementById("downGeojson")
        .setAttribute("download", this.currentProject.nombre + ".geojson");
    },
    toKMLFile() {
      // removed console log
      // removed console log
      let geojsonObject = this.currentProject.geometria;
      var kml = tokml(geojsonObject); //tokml recibe el geojson como objecto
      var convertedData =
        "application/xml;charset=utf-8," + encodeURIComponent(kml);

      // if you want to use the official MIME type for KML
      // var convertedData = 'application/vnd.google-earth.kml+xml;charset=utf-8,'+
      // encodeURIComponent(kml);

      document
        .getElementById("downKML")
        .setAttribute("href", "data:" + convertedData);
      document
        .getElementById("downKML")
        .setAttribute("download", this.currentProject.nombre + ".kml");
    },
    toSHPFile() {
      // removed console log
      var options = {
        folder: this.currentProject.nombre,
        types: {
          point: "puntos",
          polygon: "polígonos",
          line: "líneas"
        }
      };

      let info = {
        type: "FeatureCollection",
        features: [this.currentProject.geometria]
      };
      // a GeoJSON bridge for features
      shpwrite.download(info, options); //shpwrite recibe el geojson como objeto
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then(response => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    }
  },
  computed: {
    nestedStatusFicha() {
      let inSection = false;
      if (!this.currentQuestions) return [];
      return this.currentQuestions.map(q => {
        if (q.tipo === 'SECCION') {
          inSection = true;
          return false;
        }
        return inSection;
      });
    },
    filteredProjects() {
      return this.projects
        .filter(elem => {
          let date = moment(elem.fecha_creacion).format("DD/MM/YYYY");
          let new_string_search = `${date.toLowerCase()} ${elem.id.toString()} ${elem.nombre.toLowerCase()}`;

          switch (this.statusFilter) {
            case "TODOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "RECHAZADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "RECHAZADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "SIN EVALUAR":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "SIN EVALUAR" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "NO REVISADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "NO REVISADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "EN REVISIÓN":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "EN REVISIÓN" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "APROBADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "APROBADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            return new Date(a.fecha_creacion) - new Date(b.fecha_creacion);
          } else {
            return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
          }
        });
    },
    filteredByAll() {
      return this.projects;
    },
    filteredByOpen() {
      return this.projects.filter(elem => elem.status == "NO REVISADO");
    },
    filteredByChecked() {
      return this.projects.filter(elem => elem.status == "SIN EVALUAR");
    },
    filteredByAssigned() {
      return this.projects.filter(elem => elem.status == "EN REVISIÓN");
    },
    filteredByCanceled() {
      return this.projects.filter(elem => elem.status == "RECHAZADO");
    },
    filteredByAttended() {
      return this.projects.filter(elem => elem.status == "APROBADO");
    },
    htmlToPdfOptions() {
      return {
        margin: 0,

        filename: `hehehe.pdf`,

        image: {
          type: "jpeg",
          quality: 0.98
        },

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: true
        },

        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait"
        }
      };
    }
  },
  beforeMount() {
    this.fetchConfiguration();
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
